var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoAlterarPassword(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192 192",
    width: "22px",
    height: "22px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,192v-192h192v192z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#31383e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,8c-26.59048,0 -48,21.40952 -48,48v8c-8.8,0 -16,7.2 -16,16v80c0,8.8 7.2,16 16,16h96c8.8,0 16,-7.2 16,-16v-80c0,-8.8 -7.2,-16 -16,-16v-8c0,-26.59048 -21.40952,-48 -48,-48zM96,24c18.20952,0 32,13.79048 32,32v8h-64v-8c0,-18.20952 13.79048,-32 32,-32zM96,104c8.8,0 16,7.2 16,16c0,8.8 -7.2,16 -16,16c-8.8,0 -16,-7.2 -16,-16c0,-8.8 7.2,-16 16,-16z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoAlterarPassword);
export default __webpack_public_path__ + "static/media/PictoAlterarPassword.a50491d624fa8a0fc74a290ea65ae1fd.svg";
export { ForwardRef as ReactComponent };